<!--  -->
<template>
  <p class="section" :style="hasBorder ? setBorder: ''">
    <pre class="section__link" v-html="text"  :style="setStyle"/>
  </p>
</template>

<script>
export default {
  props: {
      text: {
        type: String,
      },
      globalConfig:{
        type:Object,
        default:()=>{}
      },
      hasBorder:{
        type:Number,
        default:0
      }
  },
  computed:{
    setStyle(){
      return{
        color:this.globalConfig.main
      }
    },
    setBorder(){
      const border = {
        'border-width': '1px',
        'border-style': 'solid',
        'border-radius': '8px'
      }
      return{
        borderColor:this.globalConfig.vice,
        ...border
      }
    }
  },
  methods:{
    //  setStyle(key, type) {
    //   if(this.hasBorder && type === 'borderColor'){
    //     return  setColor(this.globalConfig, key, type);
    //   }
    //   return setColor(this.globalConfig, key, type);
    // },
  }
}

</script>
<style lang='less' scoped>
.section {
  line-height: 1.5;
  margin: 25px auto 0;
  padding: 30px 38px 30px;
  width:1100px;
  box-sizing: border-box;
  text-align: left;
  font-size:16px;
  font-weight:400;
  pre{
    font-family: 'PingFang SC', 'Microsoft Yahei', 'Helvetica Neue', 'Helvetica Arial', 'Avenir', 'Segoe UI', 'Hiragino Sans GB', STHeiti, 'Microsoft Sans Serif', 'WenQuanYi Micro Hei', sans-serif;
  }
}
</style>
<style lang='less'>
.section__link {
  white-space: pre-wrap;
  // color: #FFFFFF;
  font-size: 16px;
  margin:0;
  a {
    color: #2D3866;
    text-decoration: underline;
  }
}
</style>